import moment from 'moment';
import { momentLocalizer } from 'react-big-calendar';
import { useSelector } from 'react-redux';
import { SchoolSchedule } from '../../components/common/SchoolSchedule';
import { useGetSchoolSchedulesQuery } from '../../hooks/useGetSchoolSchedulesQuery';
import { useGetTeacheIdByUserId } from '../../hooks/useGetTeacheIdByUserId';
import { RootState } from '../../redux/store';
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { Flex, Callout } from '@radix-ui/themes';
import { Link } from 'react-router-dom';
import { routes } from '../../routes';

export const TeacherSchoolSchedulePreview = () => {
  const classData = useSelector((state: RootState) => state.classes);
  const { UserId } = useSelector((state: RootState) => state.login.userData)
  const { data: teacherData } = useGetTeacheIdByUserId(UserId, { enabled: !!UserId });
  const { data: schoolSchedules, status: statusSchoolSchedule, isLoading: isLoadingSchoolSchedules, isError: isErrorSchoolSchedules, refetch: refreshSchoolSchedule } = useGetSchoolSchedulesQuery({ PageNumber: 1, PageSize: 400, IdTeacher: teacherData?.idTeacher! }, { enabled: !!teacherData?.idTeacher });
  const convertToCalendarEvents = () => {
    const currentDate = moment().startOf('week');
    return schoolSchedules?.items.map(schedule => {
      const dayIndex = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday',]
        .indexOf(schedule.dayOfTheWeek);
      schedule.description = `${schedule.subject} | ${schedule.classroom}`;
      const [startHour, startMinute] = schedule.startTime.split(':').map(Number);
      const [endHour, endMinute] = schedule.endTime.split(':').map(Number);

      const startDate = moment(currentDate)
        .add(dayIndex, 'days')
        .set('hour', startHour)
        .set('minute', startMinute)
        .toDate();

      const endDate = moment(currentDate)
        .add(dayIndex, 'days')
        .set('hour', endHour)
        .set('minute', endMinute)
        .toDate();

      return {
        title: schedule.description || "Sem descrição",
        start: startDate,
        end: endDate,
        allDay: false,
      };
    });
  };
  const events = convertToCalendarEvents();
  if (!teacherData || !teacherData.idTeacher) {
    return (
      <Flex direction="column">
        <Callout.Root color="red" role="alert">
          <Callout.Icon>
            <ExclamationTriangleIcon />
          </Callout.Icon>
          <Callout.Text>
            Entre como docente.{' '}
            <Link to={routes.dashboard} style={{ color: 'var(--gray-12)' }}>Voltar</Link>
          </Callout.Text>
        </Callout.Root>

      </Flex>
    );
  }
  return (
    <>
      <SchoolSchedule events={events} />
    </>
  );
}
